import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/leadership.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/balqees.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/female.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/male.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/olaniyan.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/qasim.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/saheed.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/shehu.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/sodiq.jpg");
